<template>
  <div class="scroll-to-top">
    <div class="enable-scroll-top">
      <div class="top">
        <h2>Scroll to top button</h2>
        <a-switch :checked="isChecked" @change="onChange" />
      </div>
      <div class="bottom">
        <p>This button moves you to the top of the page when you click it.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: {
      type: Boolean,
    },
  },
  methods: {
    onChange(checked) {
      this.$emit("scrollToTop", checked ? 1 : 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-to-top {
  position: relative;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
  }
  .enable-scroll-top {
    margin: 32px 0;
    max-width: 550px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
        margin: 0 0 15px 0;
      }
    }
    .bottom {
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
  }
}
</style>